import React, { useState, useEffect, useRef } from 'react';
import $ from 'jquery';
import "bootstrap/dist/css/bootstrap.min.css";
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";
import "datatables.net-responsive-bs5/css/responsive.bootstrap5.min.css";
import "datatables.net-bs5";
import "datatables.net-responsive-bs5";
import Header from '../Header';
import * as XLSX from 'xlsx';
import './index.css';
import { Button, Spinner } from 'react-bootstrap';

const EmpList = () => {
  const [emp, setEmp] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [taskAssignment, setTaskAssignment] = useState({
    selectedUser: '',
    selectedService: '',
    selectedTask: '',
    selectedTaskName: '',
    description: '',
    service_id: '',
    plan: '',
    customServiceName: ''
  });
  const [users, setUsers] = useState([]);
  const [services, setServices] = useState([]);
  const [plans, setPlans] = useState([]);
  const tableRef = useRef(null);
  const id = localStorage.getItem('userId');
  const [selectedEmployeeId, setSelectedEmployeeId] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const [assignTask, setAssignTask] = useState(false);
  const [serviceTasks, setServiceTasks] = useState([]);
  const [employeeId, setEmployeeId] = useState(null);
  const [managerId, setManagerId] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`https://apiaksharaconnect.aksharafinalytics.in/employee/${id}`);
        if (!response.ok) throw new Error('Network response was not ok');
        const result = await response.json();
        setEmp(result || []);
  
        // Assuming current manager is in result list
        const currentManager = result?.find(emp => emp.id === parseInt(id));
        if (currentManager) {
          setEmployeeId(currentManager.id);
          setManagerId(currentManager.mgr_id); // this may still be null if you're the top manager
          console.log('Set managerId:', currentManager.mgr_id);
        }
  
      } catch (error) {
        setError(error.message);
        setSuccessMessage(null);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [id]);

useEffect(() => {
  const fetchUsers = async () => {
    try {
      const response = await fetch(`https://apiaksharaconnect.aksharafinalytics.in/user/${id}`);
      if (!response.ok) throw new Error('Failed to fetch users');
      const data = await response.json();
      //console.log("Fetched data:", data);

      // Adjust based on actual response shape
      if (Array.isArray(data)) {
        setUsers(data);
      } else if (data && data.users && Array.isArray(data.users)) {
        setUsers(data);
      } else {
        setUsers([data]); // fallback for single user object
      }
    } catch (error) {
      setError(error.message);
      setSuccessMessage(null);
    }
  };
  fetchUsers();
}, [id]);

  useEffect(() => {
    if (emp.length > 0 && tableRef.current) {
      const table = $(tableRef.current).DataTable({
        responsive: true,
        autoWidth: false,
        destroy: true,
        paging: true,
        pageLength: 10,
        lengthMenu: [10, 25, 50, 100],
      });
      return () => {
        table.destroy();
      };
    }
  }, [emp]);

  const exportToExcel = () => {
    if (emp.length === 0) {
      alert("No data to export");
      return;
    }
    const ws = XLSX.utils.json_to_sheet(emp);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "emp");
    XLSX.writeFile(wb, "Employee_List.xlsx");
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setTaskAssignment((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleUserSelection = async (e) => {
    const selectedUserId = e.target.value;
    setTaskAssignment((prevState) => ({
      ...prevState,
      selectedUser: selectedUserId,
      selectedService: '',
      plan: '',
      customServiceName: ''
    }));
    try {
      const response = await fetch(`https://apiaksharaconnect.aksharafinalytics.in/userservices/${selectedUserId}`);
      if (!response.ok) throw new Error('Failed to fetch services');
      const data = await response.json();
      setServices(data.services || []);
      console.log()
    } catch (error) {
      setError(error.message);
      setSuccessMessage(null);
    }
  };

  const handleServiceSelection = async (e) => {
    const selectedServiceId = e.target.value;
    setTaskAssignment(prev => ({
      ...prev,
      selectedService: selectedServiceId,
      plan: '',
      customServiceName: '',
      selectedTask: ''
    }));

    const selectedService = services.find(service => service.service_id === selectedServiceId);
    setTaskAssignment(prev => ({
      ...prev,
      selectedService: selectedServiceId,
      customServiceName: selectedService?.service_name === 'Others' ? selectedService.others : ''
    }));

    try {
      const response = await fetch(`https://apiaksharaconnect.aksharafinalytics.in/userplan/${selectedServiceId}`);
      if (!response.ok) throw new Error('Failed to fetch plans');
      const data = await response.json();
      setPlans(data?.plan ? [data.plan] : []);
    } catch (error) {
      setPlans([]);
    }
  };

  const handlePlanChange = async (e) => {
    const selectedPlanId = e.target.value;
    setTaskAssignment(prev => ({
      ...prev,
      plan: selectedPlanId,
      selectedTask: ''
    }));

    try {
      const response = await fetch(`https://apiaksharaconnect.aksharafinalytics.in/getservicetask/${selectedPlanId}`);
      if (!response.ok) throw new Error('Failed to fetch service tasks');
      const data = await response.json();
      setServiceTasks(Array.isArray(data) ? data : []);
    } catch (error) {
      setServiceTasks([]);
    }
  };

  const openModal = (empId) => {
    setSelectedEmployeeId(empId);
    setIsModalOpen(true);
    setTaskAssignment({
      selectedUser: '',
      selectedService: '',
      description: '',
      service_id: '',
      plan: '',
      selectedTask: '',
      customServiceName: ''
    });
    setServices([]);
    setPlans([]);
  };

  const handleAssignTask = async () => {
    const {
      selectedUser,
      selectedService,
      plan,
      selectedTask,
      description
    } = taskAssignment;

    if (!selectedUser || !selectedService || !plan || !selectedTask || !description) {
      alert('Please fill in all required fields.');
      return;
    }

    setAssignTask(true);

    const payload = {
      user_id: selectedUser,
      mgr_id: id,
      emp_id: selectedEmployeeId,
      service_id: selectedService,
      plan_id: plan,
      service_task: selectedTask,
      Task_Description: description,
      ...(taskAssignment.selectedTaskName === 'Others' && {
        other_service_task: taskAssignment.customServiceName
      })
    };
    

    console.log(payload);

    try {
      const response = await fetch('https://apiaksharaconnect.aksharafinalytics.in/assigntask', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) throw new Error('Task assignment failed.');
      const result = await response.json();
      console.log(result);
      setSuccessMessage('Task assigned successfully!');
      setIsModalOpen(false);
    } catch (error) {
      setError(error.message || 'An error occurred during task assignment.');
    } finally {
      setAssignTask(false);
    }
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <>
      <Header />
      <div className="shadow mx-1 px-3 bg-light rounded-3">
        <div className="d-flex align-items-center justify-content-between p-3 mt-3">
          <h4 className="mb-0 me-3">Manager Team</h4>
          <button className="btn btn-success" onClick={exportToExcel}>Export to Excel</button>
        </div>

        {error && <div className="alert alert-danger">{error}</div>}
        {successMessage && <div className="alert alert-success">{successMessage}</div>}

        <div className="card">
          <div className="card-header">Team List</div>
          <div className="card-body">
            <div className="table-responsive">
              <table ref={tableRef} className="table table-striped table-bordered display nowrap" style={{ width: '100%' }}>
                <thead>
                  <tr>
                    <th>S.no</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Phone</th>
                    <th>Action</th>
                    <th>Date/Time</th>
                  </tr>
                </thead>
                <tbody>
                  {emp.length > 0 ? emp.map((emp, index) => (
                    <tr key={emp.id}>
                      <td>{index + 1}</td>
                      <td><a href={`/EmpInfo/${emp.id}`} className="text-decoration-none">
                          {emp.name || 'N/A'}
                        </a></td>
                      <td>{emp.email || 'N/A'}</td>
                      <td>{emp.phone || 'N/A'}</td>
                      <td>
                        <button className="btn btn-warning" onClick={() => openModal(emp.id)}>Assign Task</button>
                      </td>
                      <td>{emp.date || 'N/A'}</td>
                    </tr>
                  )) : (
                    <tr><td colSpan="6">No employees available</td></tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {isModalOpen && (
          <div className="modal show fade" style={{ display: 'block' }} tabIndex="-1">
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Assign Task</h5>
                  <button type="button" className="btn-close" onClick={() => setIsModalOpen(false)}></button>
                </div>
                <div className="modal-body">
                  <div className="mb-3">
                    <label className="form-label">User</label>
                    <select className="form-select" value={taskAssignment.selectedUser} onChange={handleUserSelection}>
                      <option value="">Select User</option>
                      {users.map(user => (
                        <option key={user.id} value={user.id}>{user.company}</option>
                      ))}
                    </select>
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Service</label>
                    <select className="form-select" value={taskAssignment.selectedService} onChange={handleServiceSelection}>
                      <option value="">Select Service</option>
                      {services.map(service => (
                        <option key={service.id} value={service.service_id}>{service.service_name}</option>
                      ))}
                    </select>
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Plan</label>
                    <select className="form-select" value={taskAssignment.plan} onChange={handlePlanChange}>
                      <option value="">Select Plan</option>
                      {plans.map(plan => (
                        <option key={plan.id} value={plan.plan_id}>{plan.plan_name}</option>
                      ))}
                    </select>
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Service Task</label>
                    <select className="form-select" value={taskAssignment.selectedTask} onChange={(e) => {
                      const selectedTaskId = e.target.value;
                      const selectedTaskObj = serviceTasks.find(task => task.id === selectedTaskId);
                      setTaskAssignment(prev => ({
                        ...prev,
                        selectedTask: selectedTaskId,
                        selectedTaskName: selectedTaskObj?.task_name || ''
                      }));
                    }}>
                      <option value="">Select Task</option>
                      {serviceTasks.map(task => (
                        <option key={task.id} value={task.id}>{task.task_name}</option>
                      ))}
                    </select>
                  </div>

                  {taskAssignment.selectedTaskName === 'Others' && (
                    <div className="mb-3">
                      <label className="form-label">Other Service</label>
                      <input type="text" className="form-control" value={taskAssignment.customServiceName} onChange={(e) => setTaskAssignment(prev => ({
                        ...prev,
                        customServiceName: e.target.value
                      }))} placeholder="Enter custom service name" />
                    </div>
                  )}

                  <div className="mb-3">
                    <label className="form-label">Description</label>
                    <textarea className="form-control" name="description" rows="3" value={taskAssignment.description} onChange={handleInputChange}></textarea>
                  </div>
                </div>

                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={() => setIsModalOpen(false)}>Close</button>
                  <Button variant="primary" onClick={handleAssignTask} disabled={assignTask}>
                    {assignTask ? (
                      <>
                        <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-2" />
                        Assigning...
                      </>
                    ) : "Assign Task"}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default EmpList;
